import React from "react";
import { Line } from "react-chartjs-2";
import {
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
} from "chart.js/auto";

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// plugin reused for line points
const dataLabelPlugin = {
  id: "dataLabelPlugin",
  afterDatasetsDraw: (chart: any) => {
    const { ctx, data } = chart as any;
    ctx.save();
    data.datasets.forEach((dataset: any, dsIndex: number) => {
      const meta = chart.getDatasetMeta(dsIndex);
      if (!Array.isArray(dataset.monthly)) return;
      meta.data.forEach((element: any, index: number) => {
        const change = dataset.monthly[index];
        const currVal = dataset.data && dataset.data[index];
        if (change === null || change === undefined) return;
        if (currVal === null || currVal === undefined) return;
        const x =
          element.x ?? (element?.getCenterPoint && element.getCenterPoint().x);
        const y =
          (element.y ??
            (element?.getCenterPoint && element.getCenterPoint().y)) - 10;
        ctx.fillStyle =
          dataset.borderColor ||
          dataset.backgroundColor ||
          (change > 0 ? "green" : change < 0 ? "red" : "#666");
        ctx.font = "11px Arial";
        ctx.textAlign = "center";
        const arrow = change > 0 ? "▲" : change < 0 ? "▼" : "";
        ctx.fillText(`${arrow} ${Math.abs(change)}%`, x, y);
      });
    });
    ctx.restore();
  },
};

Chart.register(dataLabelPlugin as any);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom" as const,
    },
    tooltip: {
      callbacks: {
        afterLabel: (context: any) => {
          const dataset = context.dataset;
          if (!Array.isArray(dataset.monthly)) return "";
          const monthlyPercent = dataset.monthly[context.dataIndex];
          if (monthlyPercent === null || monthlyPercent === undefined)
            return "";
          const arrow =
            monthlyPercent > 0 ? "▲" : monthlyPercent < 0 ? "▼" : "—";
          return `Growth/Loss: ${arrow} ${Math.abs(monthlyPercent)}%`;
        },
      },
    },
  },
  title: {
    display: true,
    text: "Line Chart",
  },
};

const LineChart = ({ chartData }: any) => {
  return <Line options={options} data={chartData} />;
};

export default LineChart;
